import { z } from 'zod'

export const schema = z.object({
  isin: z.string(),

  start_date: z.iso.date(),
  full_fee_date: z.iso.date(),
  start_drip_date: z.iso.date(),
  end_drip_date: z.iso.date(),

  start_fee_bps: z.number(),
  full_fee_bps: z.number(),
  end_drip_bps: z.number(),

  country: z.string().min(2),
  description: z.string().optional(),
})

export type SchemaType = z.infer<typeof schema>
